import { render, staticRenderFns } from "./CopyerCof.vue?vue&type=template&id=6f922380&scoped=true&"
import script from "./CopyerCof.vue?vue&type=script&lang=js&"
export * from "./CopyerCof.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=6f922380&lang=less&scoped=true&"
import style1 from "./CopyerCof.vue?vue&type=style&index=1&id=6f922380&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f922380",
  null
  
)

export default component.exports